<template>
    <div
        v-if="isShow"
        class="approval-response"
    >
        <i class="mtdicon mtdicon-error-circle-thick-o"></i>
        <span>驳回原因：</span>
        <span>{{ reason }}</span>
    </div>
</template>
<script>
import {
    ref, computed,
    watch,
} from '@vue/composition-api';
import { fetchHornConfig } from '@mcfe/tools';
import {
    SUPPLIER_SUBMIT_STATE_SOURCE,
    SUPPLIER_STATE,
} from '../../../list/constants';

export default {
    props: {
        approvalResponse: {
            type: Object,
            required: true,
        },
        // 审核驳回字段
        rejectionKey: {
            type: String,
            required: true,
        },
        // 审核驳回字段对应的模块
        fieldModule: {
            type: String,
            required: true,
        },
        state: {
            type: String,
            required: true,
            default: '',
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const sourceOptions = ref([]); // 驳回原因选项
        const reasonList = ref([]);
        const reasonRemark = ref(''); // 驳回原因备注

        // 更新驳回原因和备注
        const updateReasonFromList = (list) => {
            const matchedItem = list.find((item) => item.key === props.rejectionKey);
            if (matchedItem) {
                reasonList.value = matchedItem.value || [];
                reasonRemark.value = matchedItem.other || '';
            }
        };
        const isSupplierRejected = (state) => +state === SUPPLIER_STATE.SUPPLIER_REJECTED;

        const getValue = () => {
            // 处理标签同学仅审核「内包装标签」「营养成分表」和「最小零售包装（正反两面）」3个点
            if (props.state === 'supplierLabelState' && props.approvalResponse.supplierLabelState && isSupplierRejected(props.approvalResponse.supplierLabelState)) {
                updateReasonFromList(props.approvalResponse.supplierLabelReasonList);
            }
            // 处理其余由非标签同学审核
            if (props.state === 'supplierOtherState' && props.approvalResponse.supplierOtherState && isSupplierRejected(props.approvalResponse.supplierOtherState)) {
                updateReasonFromList(props.approvalResponse.supplierOtherReasonList);
            }
        };

        watch(
            () => props.approvalResponse,
            () => {
                getValue();
            },
            { immediate: true },
        );

        const getSourceOptions = async () => {
            const res = await fetchHornConfig('supplier')('rejectReason');
            sourceOptions.value = res[props.fieldModule] || [];
        };
        getSourceOptions();
        // 是否展示驳回原因
        const isShow = computed(() => props.isEdit && (reasonList.value.length || reasonRemark.value));
        const reason = computed(() => {
            const getReasonFromList = () => {
                if (!reasonList.value.length || !sourceOptions.value.length) {
                    return '';
                }
                return reasonList.value
                    .map((item) => sourceOptions.value.find((option) => option.value === item)?.label)
                    .join('、');
            };

            const combineWithRemark = (baseReason) => {
                if (!reasonRemark.value) {
                    return baseReason;
                }
                return baseReason
                    ? `${baseReason}、${reasonRemark.value}`
                    : reasonRemark.value;
            };

            const baseReason = getReasonFromList();
            return combineWithRemark(baseReason);
        });
        return {
            sourceOptions,
            reasonList,
            reason,
            isShow,
            reasonRemark,
            SUPPLIER_SUBMIT_STATE_SOURCE,
            SUPPLIER_STATE,
        };
    },
};
</script>

<style lang="scss" scoped>
.mtdicon {
    margin-right: 3px;
}
.approval-response {
    display: flex;
    justify-content: flex-start;
    flex-flow: wrap;
    align-items: center;
    word-break: break-all;
    line-height: 20px;
    padding: 6px 0 10px 0;
    color: #ff363f;
}

.reason-content-select div {
    word-break: break-all;
}
</style>
